import React from 'react';
import PropTypes from 'prop-types';
import deep from 'deep-get-set';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { Form, Button, Message, Header } from 'semantic-ui-react';
import { reduxForm } from 'redux-form/immutable';
import {
  login,
  load,
  updateUserWithShopifyToken,
  setIsSso,
  getIsSso,
  submitForSso,
  getIsSsoSubmitting,
  getHasSsoSubmitError,
  getSsoRedirectInfo
} from '../../redux/modules/auth';
import { acceptOrganizationInvite } from '../../redux/modules/organization';
import Input from '../Form/Input';
import { required, email } from '../../utils/validations';
import { queryStringToObject } from '../../helpers/commonHelper';
import UserIcon from './svg/UserIcon';
import SsoIcon from './svg/SsoIcon';
import './style.css';
import styles from './Login.module.less';

class Login extends React.Component {
  static propTypes = {
    _setIsSso: PropTypes.func,
    _submitForSso: PropTypes.func,
    dispatch: PropTypes.func,
    handleSubmit: PropTypes.func,
    isLoading: PropTypes.bool,
    loginBusy: PropTypes.bool,
    loginError: PropTypes.string,
    location: PropTypes.object,
    shopifyToken: PropTypes.string,
    shopifyStore: PropTypes.string,
    isSsoSubmitting: PropTypes.bool,
    hasSsosSubmitError: PropTypes.bool,
    ssoRedirectInfo: PropTypes.object,
    me: PropTypes.object,
    isSso: PropTypes.bool
  };

  static defaultProps = {
    dispatch: null,
    handleSubmit: null,
    isLoading: false,
    loginBusy: false,
    loginError: '',
    location: {}
  };

  constructor(props) {
    super(props);
    this.state = {
      ssoUsername: ''
    };
  }

  componentDidUpdate() {
    const redirectSsoUrl = deep(this.props, 'ssoRedirectInfo.idpUrl') || null;
    // If we have a redirect URL for SSO, navigate to it
    if (redirectSsoUrl) {
      window.location.href = redirectSsoUrl;
    }
  }

  UNSAFE_componentWillMount() {
    const { dispatch, shopifyToken, shopifyStore, location } = this.props;
    const { search } = location;

    const res = queryStringToObject(search);

    if (res && res.invite_token) {
      const inviteToken = res.invite_token;

      dispatch(acceptOrganizationInvite(inviteToken));
    }

    dispatch(load(false, shopifyToken)).then(async (res) => {
      if (res && res.id && !res.isShopifyUser && shopifyToken) {
        await dispatch(updateUserWithShopifyToken({ shopifyToken, shopifyStore }));
      }
    });
  }

  // login handler
  _login = (formData) => {
    const { dispatch } = this.props;
    const user = formData.toJS();
    dispatch(login(user.username, user.pwd));
  };

  handleSsoSubmit = () => {
    const email = this.state.ssoUsername;
    this.props._submitForSso(email);
  };

  render() {
    const {
      _setIsSso,
      handleSubmit,
      isLoading,
      loginBusy,
      loginError,
      me,
      shopifyToken,
      shopifyStore,
      isSso,
      isSsoSubmitting,
      hasSsosSubmitError,
      ssoRedirectInfo
    } = this.props;

    if (me && me.id) {
      // Let's be extra-specially sure this method exists
      // it will crash the entire app if someone is using
      // an Ad Blocker that blocks Heap from being loaded
      window.heap && window.heap.identify && window.heap.identify(me.email);
      const { from } = this.props.location.state || {
        from: { pathname: me.role === 2 ? '/campaign' : '/clients' }
      };
      return <Redirect to={from} />;
    }
    const signupUrl = shopifyToken
      ? `/signup/free/?shopifyToken=${shopifyToken}&store=${shopifyStore}`
      : 'https://videopeel.com/pricing/new-plans';

    if (isSso) {
      return (
        <div className="logincard" onSubmit={this.handleSsoSubmit}>
          <Form className="login-form">
            <Header as="h3" className="side">
              LOGIN
            </Header>
            <Input
              className="username"
              name="username"
              icon="mail"
              iconPosition="left"
              placeholder="Email"
              type="text"
              size="large"
              validate={[required, email]}
              autoCorrect="off"
              autoCapitalize="none"
              onChange={(e) => {
                this.setState(() => {
                  return { ssoUsername: e.currentTarget.value };
                });
              }}
            />
            <Button
              className="ui large fluid button front"
              type="submit"
              primary
              loading={isSsoSubmitting}
            >
              Login
              <i aria-hidden="true" className="chevron right icon"></i>
            </Button>
            <p className="signcentered">
              {' '}
              <a href={signupUrl}>
                No account? <span>Sign Up</span>
              </a>
            </p>
            <p className="homecentered">
              <a href="">
                <i aria-hidden="true" className="home icon"></i>Back to Home
              </a>
            </p>
            <div
              className={styles.vpAuthTypeButton}
              role="button"
              onClick={(e) => {
                e.preventDefault();
                _setIsSso(false);
              }}
            >
              <UserIcon />
              Username/Password
            </div>
          </Form>

          {hasSsosSubmitError && (
            <Message style={{ bottom: '24px' }} error content={ssoRedirectInfo.response.message} />
          )}
        </div>
      );
    }

    return (
      <div className="logincard" onSubmit={handleSubmit(this._login)}>
        <Form className="login-form">
          <Header as="h3" className="side">
            LOGIN
          </Header>
          <Input
            className="username"
            name="username"
            icon="user"
            iconPosition="left"
            placeholder="Username"
            type="text"
            size="large"
            validate={[required, email]}
            autoCorrect="off"
            autoCapitalize="none"
            onChange={(e) => {
              this.setState(() => {
                return { ssoUsername: e.currentTarget.value };
              });
            }}
          />
          <Input
            name="pwd"
            icon="key"
            iconPosition="left"
            placeholder="Password"
            type="password"
            size="large"
            validate={[required]}
          />
          <Button
            className="ui large fluid button front"
            type="submit"
            primary
            loading={isLoading || loginBusy}
          >
            Login
            <i aria-hidden="true" className="chevron right icon"></i>
          </Button>
          <p className="signcentered">
            {' '}
            <a href={signupUrl}>
              No account? <span>Sign Up</span>
            </a>
          </p>
          <p className="signcentered">
            {' '}
            <a href="./forgot/password">
              Forgot Password? <span>Click Here</span>
            </a>
          </p>
          <p className="homecentered">
            <a href="">
              <i aria-hidden="true" className="home icon"></i>Back to Home
            </a>
          </p>
          <div
            className={styles.vpAuthTypeButton}
            role="button"
            onClick={(e) => {
              e.preventDefault();
              _setIsSso(true);
            }}
          >
            <SsoIcon />
            SSO User?
          </div>
        </Form>

        {loginError && <Message error content={loginError} />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    me: state.get('auth').get('user'),
    isLoading: state.get('auth').get('isLoad'),
    loginBusy: state.get('auth').get('isLogin'),
    loginError: state.get('auth').get('loginErr'),
    isSso: getIsSso(state),
    isSsoSubmitting: getIsSsoSubmitting(state),
    hasSsosSubmitError: getHasSsoSubmitError(state),
    ssoRedirectInfo: getSsoRedirectInfo(state)
  };
}

const mapDispatchToProps = {
  _setIsSso: setIsSso,
  _submitForSso: submitForSso
};

export { Login as DisconnectedLogin };

const form = reduxForm({ form: 'login' })(Login);
export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js